const LATIN_LOCALE = 'ar-LY-u-nu-latn';

const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatNumber = (value, options = {}) => {
  const num = Number(value ?? 0);
  if (!Number.isFinite(num)) return '0';
  return new Intl.NumberFormat(LATIN_LOCALE, {
    maximumFractionDigits: 2,
    ...options,
    numberingSystem: 'latn'
  }).format(num);
};

export const formatDate = (value, options = {}) => {
  const date = toDate(value);
  if (!date) return '-';
  return new Intl.DateTimeFormat(LATIN_LOCALE, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options,
    numberingSystem: 'latn'
  }).format(date);
};

export const formatDateShort = (value) => {
  const date = toDate(value);
  if (!date) return '-';
  return new Intl.DateTimeFormat(LATIN_LOCALE, {
    month: '2-digit',
    day: '2-digit',
    numberingSystem: 'latn'
  }).format(date);
};

// Format date as day + month name (e.g., "14 March", "7 February")
// Uses Arabic month names for Arabic locale, English for English locale
export const formatDateDayMonth = (value, locale = 'ar') => {
  const date = toDate(value);
  if (!date) return '-';
  
  // Use Arabic locale for day names, but with explicit month names
  const arabicMonths = [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ];
  const englishMonths = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const day = date.getDate();
  const monthIndex = date.getMonth();
  
  if (locale === 'ar') {
    return `${day} ${arabicMonths[monthIndex]}`;
  }
  return `${day} ${englishMonths[monthIndex]}`;
};

export const formatDateTime = (value, options = {}) => {
  const date = toDate(value);
  if (!date) return '-';
  return new Intl.DateTimeFormat(LATIN_LOCALE, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...options,
    numberingSystem: 'latn'
  }).format(date);
};

export const formatTime = (value, options = {}) => {
  const date = toDate(value);
  if (!date) return '-';
  return new Intl.DateTimeFormat(LATIN_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    ...options,
    numberingSystem: 'latn'
  }).format(date);
};

export const formatPercent = (value, fractionDigits = 2) => `${formatNumber(value, {
  minimumFractionDigits: fractionDigits,
  maximumFractionDigits: fractionDigits
})}%`;

export const formatCurrency = (value, currency = 'LYD') => {
  const num = Number(value ?? 0);
  if (!Number.isFinite(num)) return '-';
  return new Intl.NumberFormat(LATIN_LOCALE, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    numberingSystem: 'latn'
  }).format(num);
};

export const formatDurationHours = (hours) => `${formatNumber(hours, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})} h`;

